import locale from '../locale/default';
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/locale-provider/default.js
// module id = 460
// module chunks = 0